// The booking notes' length cap (23 Oct 2026: an 843-character note broke
// checkout four times over, Sentry GOWASHMYCAR-M). The server no longer
// sends notes to Stripe, so the cap is about a readable note for the
// operator, not a Stripe limit. The counter shows only near the cap.
export const NOTES_MAX_LENGTH = 1000
export const NOTES_COUNTER_FROM = 800

// The note as the field keeps it: never longer than the cap (a paste or a
// restored draft can be).
export const clampNotes = value => {
  const text = value == null ? '' : String(value)
  return text.length > NOTES_MAX_LENGTH ? text.slice(0, NOTES_MAX_LENGTH) : text
}

// "843 / 1000" once the note is near the cap, else null (no counter).
export const notesCounter = value => {
  const length = value == null ? 0 : String(value).length
  return length >= NOTES_COUNTER_FROM ? `${Math.min(length, NOTES_MAX_LENGTH)} / ${NOTES_MAX_LENGTH}` : null
}
